
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 13 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 14 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import moment from "moment";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action, State } from "vuex-class";

import { JobFairEventModel, JobFairModel } from "@/models/job.model";
import { enumKeyInput } from "@/constants/enum.constant";
import toast from "@/functions/toast.function";

@Component
export default class ModalAddEvent extends Vue {
  /* VUEX */

  /* ACTIONS */
  @Action("actionGetEventJobfair", { namespace: "job" })
  public actionGetEventJobfair: any;
  @Action("actionAddEventJobfair", { namespace: "job" })
  public actionAddEventJobfair: any;

  /* STATE */
  @State("job_fair_event", { namespace: "job" })
  public job_fair_event: JobFairEventModel;

  @State("job_fair", { namespace: "job" })
  public job_fair: JobFairModel;

  /* PROPS */
  @Prop({ default: false })
  public isShow: boolean;

  /* INITIALIZATION */
  public enumKeyInput = enumKeyInput;

  public get minEventDate() {
    return moment(Date.now()).format("YYYY-MM-DD");
  }

  /* METHOD */

  public clickSubmit() {
    if (this.job_fair.id) {
      this.actionAddEventJobfair({
        success: () => {
          this.actionGetEventJobfair();
          this.$emit("update:isShow", false);
        },
      });
    } else toast.warning(this.$t('warning_empty_jobfair_add_event'));
  }

  public changeStartTime(event: any) {
    const val = event.target.value;

    if (event.inputType === this.enumKeyInput.DELETE) {
      this.job_fair_event.start_time = val;
    } else if (val && val.length == 2) {
      if (!this.job_fair_event.start_time.includes(":")) {
        this.job_fair_event.start_time = val + ':';
      }
    }
  }

  public changeEndTime(event: any) {
    const val = event.target.value;

    if (event.inputType === this.enumKeyInput.DELETE) {
      this.job_fair_event.end_time = val;
    } else if (val && val.length == 2) {
      if (!this.job_fair_event.end_time.includes(":")) {
        this.job_fair_event.end_time = val + ':';
      }
    }
  }

  public formatTime(e: string) {
    return String(e).substring(0, 5);
  }
}
